<div class="header-container" [class.shrink]="isScrolled" *ngIf="isLoggedIn; else loginPageHeader">
    <div class="menu-container d-print-none">
        <svg *ngIf="!onDashboardPage" (click)="gotoDashboard()" class="menu-icon-svg" width="32" height="32"
            viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 18H20M4 12H20M4 6H20" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
        </svg>
    </div>
    <div class="text-center w-100">
        <img class="header-logo" src="/assets/images/prp-header.png" alt="Concourse Resource Portal">
    </div>
    <div class="user-info-container d-print-none">
        <table>
            <tr>
                <td><img [src]="user.photo || placeholderImage" height="40px"></td>
                <td>
                    <div ngbDropdown>
                        <button class="btn btn-default" id="dropdownConfig" ngbDropdownToggle>
                            <div class="username">{{user?.firstname || 'User'}} {{user?.lastname?.substr(0,1)}}</div>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownConfig">
                            <button (click)="userProfile()" ngbDropdownItem>Profile</button>
                            <button (click)="logout()" ngbDropdownItem>Logout</button>
                        </div>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</div>
<ng-template #loginPageHeader>
    <div class="login-header-container">
        <img [routerLink]="['/']" src="/assets/images/prp-header-login.png" height="60" alt="">
    </div>
</ng-template>